import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigSharedService} from '../../services/get-config-shared.service';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../reducers';
import {LoadLinkContractAction, LoadLinkContractUpdateCompanyNameAction} from '../../actions/contract-link';
import {LoadSubscriptionsLinkContractAction} from '../../actions/subscription-link-contract';
import * as moment from 'moment';
import * as _ from 'lodash';
import {ActivatedRoute, Router} from '@angular/router';
import {UpdateLinkContractAction} from '../../actions/link-contract-update';
import {ContractLinkForm} from '../../models/contract-link';
import {CommonField} from '../../models/common-field';
import * as fromCompanies from '../../../company/reducers';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ModalComponent} from '@storever/modal-confirmation';
import {SelectedItem} from '../../../order/models/order';
import * as fromRoot from '../../reducers';
import {ClearOneItemSubListAction, ClearSubListAction} from '../../actions/subscription-list';
import {CompanyClearAction} from '../../../company/actions/company-load';
import {Product} from '../../models/product';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {LoadMyCompaniesLinkContractAction} from '../../actions/companies-link-contract';
import {ConsoleLogger} from '@angular/compiler-cli/ngcc';
import {AddInvoiceManagementAction} from '../../actions/invoice-management';

@Component({
  selector: 'storever-invoices-management-modal',
  templateUrl: './invoices-management-modal.component.html',
  styleUrls: ['./invoices-management-modal.component.css']
})
export class InvoicesManagementModalComponent  implements OnInit, OnDestroy {
  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  private sub$: Subscription;
  private subscriptions = [];
  @Input() contractName: string;
  @Input() contractUuid: string;
  @Input() companyName: string = null;
  @Input() companyUuid: string = null;
  productList: Product[];
  selectedItem$: Observable<SelectedItem[]>;
  selectedOneItem$: Observable<SelectedItem>;
  // tslint:disable-next-line:no-any
  selectedItem: any[];
  // tslint:disable-next-line:no-any
  selectedOneItem: any;
  // tslint:disable-next-line:no-any
  @Input() productID: any;
  myForm: FormGroup;
  formConfig: GroupConfig;
  error = 'false';
  isBillingLinked: boolean;
  // tslint:disable-next-line:no-any
  selectedSub: any [] = [];
  product$: Observable<Product[]>;

  constructor(private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private activatedRoute: ActivatedRoute,
              private bsModalRef: BsModalRef,
              private bsModalRefConfirmation: BsModalRef,
              private storeCompany: Store<fromCompanies.AppState>,
              private modalService: BsModalService,
              private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private storeRoot: Store<fromRoot.AppState>,
              private store: Store<fromShared.AppState>) {
    this.product$ = this.storeRoot.pipe(select(fromRoot.selectors.getProducts))
    this.product$.subscribe(product => {if (product) {this.productList = product} });
  }


  ngOnInit(): void {
    this.getSelectItemsInfo();
    this.formConfig = this.getConfigSharedService.getInvoicesManagement();
    this.myForm = this.getFormsService.getInvoicesManagement();


  }

  send(value: ContractLinkForm): void {

      this.store.dispatch(new AddInvoiceManagementAction({data: value , subList: this.selectedSub }));
      this.close();

  }

  open(): void {
    this.staticModal.show();
  }

  close(): void {
     this.myForm.reset();
     if (this.staticModal) {
      this.staticModal.hide();
    } else {
      this.bsModalRef.hide();
    }
  }

  remove(index: number): void {
    if (index > -1) {
      this.selectedSub.splice(index, 1);
    }
  }
  checkProductType(): boolean {
    let isProductSame = true;
    if (this.selectedItem && this.selectedItem.length > 0) {
      const productTmp = this.selectedItem[0].productName;
      for (let i = 0; i < this.selectedItem.length; ++i) {
        if (this.selectedItem[i].productName !==  productTmp) {
          isProductSame = false;
        }
      }
    }
    return isProductSame;
  }

  removeSubscription(index: number): void {
    if (this.selectedItem.length > 1) {
      let selectedItemTemp;
      selectedItemTemp = _.cloneDeep(this.selectedItem);
      if (index > -1) {
        selectedItemTemp.splice(index, 1);
      }
      this.selectedItem = selectedItemTemp;
      this.selectedSub = selectedItemTemp;
    }

  }
  // this fonction is used when we call this modal via data table
  closeBSF(): void {
    this.myForm.reset();
    this.selectedSub = [];
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
        if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  getSelectItemsInfo(): void {
    this.selectedItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedSubList));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedItem$.subscribe((data: any[]) => {
      if (data) {
        this.selectedSub = [];
        this.selectedItem = data;
        for (let j = 0; j < this.selectedItem.length; j++) {
          this.selectedSub.push({
            subscriptionUuid: this.selectedItem[j].uuid,
            contractUuid: this.selectedItem[j].contractUuid,
            companyUuid: this.selectedItem[j].companyUuid,
          });
        }
      }

    });
    this.subscriptions.push(this.sub$);
    this.selectedOneItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedOneSubscription));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedOneItem$.subscribe((data: any) => {
      if (data) {
        this.selectedOneItem = data;
        this.selectedSub.push({
          subscriptionUuid: data.uuid,
          contractUuid: data.contractUuid,
          companyUuid: data.companyUuid,
        });
      }

    });
    this.subscriptions.push(this.sub$);
  }

}

